/* =========================================================
   CARSKETCH KARTSPOT PROMO POPUP
   Shows only on:
   - Product Type: Karting Parts
   - Product Type: Helmet Parts
   - Collection: karting-helmet-parts
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

    const POPUP_KEY = 'carsketch_kartspot_seen';
    const SHOW_DELAY = 1800;

    // Show only once per browser session
    if (sessionStorage.getItem(POPUP_KEY)) {
        return;
    }

    // Read exact Shopify page data from theme.liquid
    const pageData = window.CarsketchPageData || {};

    const productType = String(pageData.productType || '')
        .trim()
        .toLowerCase();

    const collectionHandle = String(pageData.collectionHandle || '')
        .trim()
        .toLowerCase();

    // Exact targeting
    const isKartingProduct =
        productType === 'karting parts' ||
        productType === 'helmet parts';

    const isKartingCollection =
        collectionHandle === 'karting-helmet-parts';

    // Do nothing everywhere else
    if (!isKartingProduct && !isKartingCollection) {
        return;
    }

    // Language detection
    const lang = (document.documentElement.lang || 'en').toLowerCase();
    const isGreek = lang.startsWith('el');

    const overlay = document.createElement('div');
    overlay.id = 'carsketch-holiday-overlay';

    overlay.innerHTML = `
        <div
            id="carsketch-holiday-popup"
            class="kartspot-popup"
            role="dialog"
            aria-modal="true"
            aria-label="KartSpot promotion"
        >

            <button
                id="carsketch-holiday-close"
                aria-label="Close"
                type="button"
            >
                &times;
            </button>

            <img
                src="https://cdn.shopify.com/s/files/1/0854/7454/1916/files/kartspot-logo.png?v=1787638740"
                alt="KartSpot"
                class="kartspot-popup-logo"
            >

            <div class="kartspot-popup-motto">
                EVERYTHING YOU NEED. NOTHING YOU DON’T.
            </div>

            <div class="kartspot-popup-trial">
                ${isGreek ? '30 ΗΜΕΡΕΣ ΔΩΡΕΑΝ' : '30 DAYS FREE'}
            </div>

            <p class="kartspot-popup-main">
                ${
                    isGreek
                        ? 'Live εργαλείο στρατηγικής για endurance karting.'
                        : 'Live strategy software built for endurance karting.'
                }
            </p>

            <div class="kartspot-popup-features">
                ${
                    isGreek
                        ? 'Ρυθμός • Pit Status • Stints • Ποιότητα Kart • Handovers'
                        : 'Pace • Pit Status • Stints • Kart Quality • Handovers'
                }
            </div>

            <div class="kartspot-popup-platforms">
                Apex Timing & RaceFacer
            </div>

            <a
                id="carsketch-popup-continue"
                class="kartspot-primary-button"
                href="https://kartspot.app/"
                target="_blank"
                rel="noopener noreferrer"
            >
                ${
                    isGreek
                        ? 'ΔΟΚΙΜΑΣΕ ΤΟ KARTSPOT'
                        : 'TRY KARTSPOT FREE'
                }
            </a>

            <a
                class="carsketch-kartspot-instagram kartspot-instagram-button"
                href="https://www.instagram.com/kartspot.app/"
                target="_blank"
                rel="noopener noreferrer"
            >
                FOLLOW @KARTSPOT.APP
            </a>

        </div>
    `;

    document.body.appendChild(overlay);

    function markAsSeen() {
        sessionStorage.setItem(POPUP_KEY, '1');
    }

    function closePopup() {
        overlay.classList.remove('is-visible');
        markAsSeen();

        setTimeout(function () {
            overlay.remove();
        }, 300);
    }

    const closeButton =
        document.getElementById('carsketch-holiday-close');

    const kartspotButton =
        document.getElementById('carsketch-popup-continue');

    const instagramButton =
        document.querySelector('.carsketch-kartspot-instagram');

    if (closeButton) {
        closeButton.addEventListener('click', closePopup);
    }

    if (kartspotButton) {
        kartspotButton.addEventListener('click', markAsSeen);
    }

    if (instagramButton) {
        instagramButton.addEventListener('click', markAsSeen);
    }

    // Click outside popup closes it
    overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
            closePopup();
        }
    });

    // ESC closes popup
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.contains(overlay)) {
            closePopup();
        }
    });

    // Show popup
    setTimeout(function () {
        overlay.classList.add('is-visible');
    }, SHOW_DELAY);

});